// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"9479a59925a64740","777":"6e4a0bea1b9a7f02"}[chunkId] + ".js";
};